<template>
  <div class="legend-item">
    <div>
      <span class="legend-label">{{ $t('Webportal.Legend.Change') }}</span>
    </div>
    <div class="legend-values">
      <div class="legend-value">
        <Triangle :size="12" class="value-icon triangle-up" />
        <span class="value-text">{{ $t('Webportal.Legend.Improvement') }}</span>
      </div>
      <div class="legend-value">
        <Triangle :size="12" class="value-icon triangle-down" />
        <span class="value-text">{{ $t('Webportal.Legend.Deterioration') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Triangle } from 'lucide-vue-next';

export default {
  name: 'LegendUpDownTick',

  components: {
    Triangle
  }
};
</script>

<style lang="scss" scoped>
.legend-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 12rem;
}

.legend-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--bs-body-color);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.legend-subtitle {
  font-size: 10px;
  font-weight: 300;
  color: var(--bs-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.00em;
}

.legend-values {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 0px;
  column-gap: 12px;
}

.legend-value {
  display: flex;
  align-items: center;
  gap: 6px;
}

.color-indicator {
  width: 4px;
  height: 14px;
  border-radius: var(--radius-xs);
  transform: skewX(var(--target-skew-angle-inverse));
}

.value-icon {
  flex-shrink: 0;
  color: var(--bs-secondary-color);
}

.triangle-up {
  color: var(--default-status-green);
  fill: var(--default-status-green);
  transform: rotate(0deg);
}

.triangle-down {
  color: var(--default-status-red);
  fill: var(--default-status-red);
  transform: rotate(180deg);
}

.value-text {
  font-size: 0.6875rem;
  color: var(--bs-secondary-color);
}
</style>
